import { bindActionCreators } from 'redux'
import { Link } from '@piconetworks/login'
import withInjection from '@piconetworks/with-injection'

import Account from 'common/modules/account'
import Internal from 'common/modules/internal'
import Loader from 'common/modules/loader'
import Wizard from 'common/modules/wizard'
import Zoid from 'common/modules/zoid'

import WizardRedux from 'common/pkgs/WizardRedux'

const mapStateToProps = (state, props) => ({
    ...props,
    publisherId: state.loader.guest.publisher.id,
    thisWizard: Wizard.selectors.thisWizard({ state, router: props.router }),
    loginEmail: Account.selectors.loginEmail(state),
    loginLinkSent: state.account.loginLinkSent,
    loginLinkError: state.account.loginLinkError,
    redirectUrl: state.zoid?.xprops?.content?.url,
    utm: Zoid.selectors.getUTM(state),
    guestLoader: state?.loader?.guest,
    loaderIsFetching: state?.loader?.isFetching,
    userLoader: state?.loader?.user,
    updateLoaderUserNewsletters: (args) => Internal.creators.sendMessage({
        payload: {
            target: 'pico_arbiter',
            ...Loader.creators.updateLoaderUserNewsletters(args),
        },
    }),
    WizardRedux,
})

const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators({
        requestLoginLink: Account.creators.requestLoginLink,
    }, dispatch),
    newsletterSubscribe: (payload) => Internal.helpers.invalidateLoader({
        payload,
        action: Account.creators.newsletterSubscribe,
        dispatch,
    }),
    dispatch,
})

let loaderDidFetch = false

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const fetchUserLoader = (
        stateProps.accessToken
        && !stateProps.loaderIsFetching
        && !stateProps.userLoader
    )

    if (fetchUserLoader && !loaderDidFetch) {
        loaderDidFetch = true
        dispatchProps.dispatch(Internal.creators.sendMessage({
            payload: {
                target: 'pico_arbiter',
                type: 'LOADER/INVALIDATION_EVENT',
                scope: [
                    'user',
                ],
            },
        }))
    }

    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        onBackButtonClick: () => {
            dispatchProps.initialize()
            stateProps.onBackButtonClick()
        },
    }
}

const InjectedLink = withInjection(Link, {
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
})

export default InjectedLink
